import { DOCUMENT } from '@angular/common';
import { Inject, Injectable, OnDestroy } from '@angular/core';

/** Cores de dados da API: validação estrita e regras CSS compartilhadas por referência. */
@Injectable({ providedIn: 'root' })
export class AppDataColorService implements OnDestroy {
  private readonly references = new Map<string, number>();
  private stylesheet?: HTMLStyleElement;

  constructor(@Inject(DOCUMENT) private document: Document) {}

  normalize(value: string): string {
    if (!/^#[0-9a-fA-F]{6}$/.test(value)) throw new Error('Cor de categoria inválida: esperado hexadecimal de seis dígitos.');
    return value.toLowerCase();
  }

  acquire(value: string): string {
    const color = this.normalize(value);
    const references = this.references.get(color) ?? 0;
    this.references.set(color, references + 1);
    if (!references) this.updateStylesheet();
    return `app-data-color-${color.slice(1)}`;
  }

  release(value: string): void {
    const color = this.normalize(value);
    const references = this.references.get(color);
    if (!references) return;
    if (references > 1) this.references.set(color, references - 1);
    else {
      this.references.delete(color);
      this.updateStylesheet();
    }
  }

  private updateStylesheet(): void {
    if (!this.references.size) {
      this.stylesheet?.remove();
      this.stylesheet = undefined;
      return;
    }
    if (!this.stylesheet) {
      this.stylesheet = this.document.createElement('style');
      this.stylesheet.setAttribute('data-app-data-colors', '');
      this.document.head.appendChild(this.stylesheet);
    }
    this.stylesheet.textContent = Array.from(this.references.keys(), color =>
      `.app-data-color-${color.slice(1)} { --app-filter-color: ${color}; }`).join('\n');
  }

  ngOnDestroy(): void {
    this.references.clear();
    this.stylesheet?.remove();
  }
}
